export const SEARCH_RESULT_TYPES = {
  brand: 'brand',
  category: 'category',
  content: 'content',
  offer: 'offer',
};
